import React, { useContext, useEffect, useState } from 'react';
import './Walkthrough.scss'
import AppContext from '../../context/AppContext';

const Walkthrough = (props) => {
    const { context, showHeader } = useContext(AppContext);
    const [currentTime, setCurrentTime] = useState(0);

    useEffect(() => {
        showHeader(false);
        const ct = (new Date()).getTime();
        setCurrentTime(ct)
        return () => {
            showHeader(true);
        };
    }, []);

    return (
        <div className="walkthrough">
            <div>
                {props.levelInfo.hideChapterNumber ? "" : <h5>Chapter {`${props.levelInfo.chapter}`} of 2</h5>}
                <h1>{props.gameTitle ? props.gameTitle : "Color Match"}</h1>
                <p>
                    {props.description}
                </p>
                <button onClick={() => {
                    const timeNow = (new Date()).getTime();
                    props.setWalkthroughTime(((timeNow - currentTime) / 1000).toFixed(2))
                    props.onClick();
                }} className={`questionOptions style-4`}>
                    <span>Start Tutorial</span>
                </button>
            </div>
        </div>
    );
}

export default Walkthrough